/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Integrate_Directory_DescriptionInputs */

const en_directory_integrate_directory_description = /** @type {(inputs: Directory_Integrate_Directory_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find products and inspect the structured product information available today.`)
};

const zh_directory_integrate_directory_description = /** @type {(inputs: Directory_Integrate_Directory_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查找产品并查看当前可用的结构化产品信息。`)
};

/**
* | output |
* | --- |
* | "Find products and inspect the structured product information available today." |
*
* @param {Directory_Integrate_Directory_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_integrate_directory_description = /** @type {((inputs?: Directory_Integrate_Directory_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Integrate_Directory_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_integrate_directory_description(inputs)
	return zh_directory_integrate_directory_description(inputs)
});
export { directory_integrate_directory_description as "directory.integrate.directory.description" }